/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Free_ActivatedInputs */

const en_billing_free_activated = /** @type {(inputs: Billing_Free_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The voucher covered the full price — your plan is active.`)
};

const id_billing_free_activated = /** @type {(inputs: Billing_Free_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voucher menutup seluruh harga — paket kamu sudah aktif.`)
};

/**
* | output |
* | --- |
* | "The voucher covered the full price — your plan is active." |
*
* @param {Billing_Free_ActivatedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_free_activated = /** @type {((inputs?: Billing_Free_ActivatedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Free_ActivatedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_free_activated(inputs)
	return en_billing_free_activated(inputs)
});